import { withEditableArea } from '@trendkite/ui';
import StoryContactDisplay from './StoryContactDisplay';
import EditStoryContact from './EditStoryContact';

export default withEditableArea(StoryContactDisplay, EditStoryContact);
